<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">Пояснительная записка</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="table-container">
            <b-table
                v-if="enTableNumbers.includes(this.table_number) || table_number === 36 || table_number === 37"
                :items="formApp"
                :fields="tableFields1_1"
                :tbody-tr-class="rowClass"
                responsive
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true"
                class="text-center"
            >
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="3" class="text-center"></b-th>
                        <b-th colspan="1" class="text-center">{{ 'Факт, тыс. теңге' }}</b-th>
                        <b-th colspan="1" class="text-center">{{ 'Оценка, тыс. теңге' }}</b-th>
                        <b-th colspan="3" class="text-center">{{ 'Прогноз, тыс. теңге' }}</b-th>
                    </b-tr>
                </template>
                <template v-if="table_number !== 3" #bottom-row="data">
                    <b-th colspan="1" class="text-right"></b-th>
                    <b-th colspan="1" class="text-left">{{'Всего'}}</b-th>
                    <b-th colspan="1" class="text-center">{{'100'}}</b-th>
                    <b-th colspan="1" class="text-right">
                        <span
                        v-if="(table_number === 36 || table_number === 37) && hasError('fact')"
                        :title="hasError('fact').text"
                        class="warning-icon">⚠</span>{{ $n(totalRow.fact) }}
                    </b-th>
                    <b-th colspan="1" class="text-right">
                        <span
                            v-if="(table_number === 36 || table_number === 37) && hasError('evaluation')"
                            :title="hasError('evaluation').text"
                            class="warning-icon">⚠</span>{{ $n(totalRow.evaluation) }}
                    </b-th>
                    <b-th colspan="1" class="text-right">
                        <span
                            v-if="(table_number === 36 || table_number === 37) && hasError('forecast_1')"
                            :title="hasError('forecast_1').text"
                            class="warning-icon">⚠</span>{{ $n(totalRow.forecast_1) }}
                    </b-th>
                    <b-th colspan="1" class="text-right">
                        <span
                            v-if="(table_number === 36 || table_number === 37) && hasError('forecast_2')"
                            :title="hasError('forecast_2').text"
                            class="warning-icon">⚠</span>{{ $n(totalRow.forecast_2) }}
                    </b-th>
                    <b-th colspan="1" class="text-right">
                        <span
                            v-if="(table_number === 36 || table_number === 37) && hasError('forecast_3')"
                            :title="hasError('forecast_3').text"
                            class="warning-icon">⚠</span>{{ $n(totalRow.forecast_3) }}
                    </b-th>
                </template>
                <template #cell(spf)="data">
                    <div>{{ data.value }}</div>
                </template>
                <template #cell(name_ru)="data">
                    <div class="text-left" style="width: 600px">
                        {{ data.value }}<span v-if="table_number === 36 && data.item.spf === 159">*</span>
                    </div>
                </template>
                <template #cell(row_code)="data">
                    <div class="text-center">{{ data.value }}</div>
                </template>
                <template #cell()="data">
                    <div class="text-right">
                        <template v-if="table_number === 8 && inputType8.includes(data.item.row_code)
                                        && hasParentValues(data.item.row_code, data.field.key)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="blurInput(data, data.item.row_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="table_number === 7 && inputType7.includes(data.item.row_code) &&
                                         data.field.key === 'fact' && hasParentValues(data.item.row_code, data.field.key)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="blurInput(data, data.item.row_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else>
                            {{ toNum(data.value) === 0 ? null : $n(toNum(data.value)) }}
                        </template>
                    </div>
                </template>
            </b-table>
            <b-table
                v-if="changeTableNumbers.includes(this.table_number) || table_number === 9 || table_number === 20 || table_number === 25"
                :items="formApp"
                :fields="tableFields1_2"
                responsive
                bordered
                head-variant="light"
                no-border-collapse
                sticky-header="true"
                class="text-center"
            >
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="2" class="text-center"></b-th>
                        <b-th colspan="1" class="text-center">{{ 'Факт, тыс. теңге' }}</b-th>
                        <b-th colspan="1" class="text-center">{{ 'Оценка, тыс. теңге' }}</b-th>
                        <b-th colspan="3" class="text-center">{{ 'Прогноз, тыс. теңге' }}</b-th>
                    </b-tr>
                </template>
                <template #cell(name_ru)="data">
                    <div class="text-left" style="width: 300px">{{ data.value }}</div>
                </template>
                <template #cell(row_code)="data">
                    <div class="text-center">{{ data.value }}</div>
                </template>
                <template #cell()="data">
                    <div class="text-right">
                        <template v-if="table_number === 9 && ['010', '011'].includes(data.item.row_code)">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="blurInput(data, data.item.row_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else-if="(table_number === 19 || table_number === 24) && !data.item.row_code.endsWith('0')">
                            <input type="number"
                                   v-model.number="data.value"
                                   @blur="blurInput(data, data.item.row_code)"
                                   :class="{ 'disabled-input': access_level === 1 || !actualVersion }"
                                   :disabled="access_level === 1 || !actualVersion"
                                   class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                        </template>
                        <template v-else>
                            {{ toNum(data.value) === 0 ? null : $n(toNum(data.value)) }}
                        </template>
                    </div>
                </template>
            </b-table>
            <!--  Строка примечаний   -->
            <table v-if="[18, 19, 20, 24, 25, 36].includes(table_number)" class="table table-bordered text-center mt-0">
                <tbody>
                <tr v-if="table_number === 18">
                    <td colspan="6" class="text-left text-muted small">
                        *в таблице 18 отражаются краткосрочные финансовые обязательства сроком погашения до 1 года после
                        отчетной даты, за исключением текущей части долгосрочных обязательств.
                        Текущая часть долгосрочных финансовых обязательств сроком погашения до 1 года после отчетной даты,
                        отражается в общей сумме долгосрочных обязательств в таблице 23 и с выделением от общей суммы долгосрочных
                        обязательств в таблицах 24 и 27.
                    </td>
                </tr>
                <tr v-if="table_number === 19">
                    <td colspan="6" class="text-left text-muted small">
                        *в таблице 19 отражаются краткосрочные финансовые обязательства сроком погашения до 1 года после отчетной даты,
                        за исключением текущей части долгосрочных обязательств. Текущая часть обязательств долгосрочных финансовых
                        обязательств сроком погашения до 1 года после отчетной даты, отражается в таблице 25.
                    </td>
                </tr>
                <tr v-if="table_number === 20">
                    <td colspan="6" class="text-left text-muted small">
                        *сальдо краткосрочных финансовых обязательств по государственным эмиссионным бумагам, внешним и внутренним займам на конец периода.<br>
                        ** сальдо краткосрочных финансовых обязательств по договорам концессии на конец периода (строка 401 таблицы 27).<br>
                        *** сальдо краткосрочных финансовых обязательств по прочим договорам государственно-частного партнерства на конец периода (строка 401 таблицы 31).
                    </td>
                </tr>
                <tr v-if="table_number === 24">
                    <td colspan="6" class="text-left text-muted small">
                        *текущая часть долгосрочных обязательств (краткосрочные обязательства) отражается по коду строки
                        210 прогнозного консолидированного отчета о финансовом положении.
                    </td>
                </tr>
                <tr v-if="table_number === 25">
                    <td colspan="6" class="text-left text-muted small">
                        *сальдо долгосрочных финансовых обязательств по государственным эмиссионным бумагам, внешним и внутренним займам на конец периода.<br>
                        **сальдо долгосрочных финансовых обязательств по договорам концессии на конец периода (строка 402 таблицы 27).<br>
                        ***сальдо долгосрочных финансовых обязательств по прочим договорам государственно-частного партнерства на конец периода (строка 402 таблицы 31).
                    </td>
                </tr>
                <tr v-if="table_number === 36">
                    <td colspan="6" class="text-left text-muted small">
                        * не включается сумма по содержанию и текущий ремонт долгосрочных активов.
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import moment from "moment";
import {Ax} from "@/utils";

const TABLE_8_CHILD_TO_PARENT = {
    '011': '010',
    '012': '010',
    '013': '010',
    '015': '014',
    '016': '014',
    '017': '014'
};

const TABLE_7_CHILD_TO_PARENT = {
    '012': '011',
    '013': '011',
    '016': '015'
};

export default {
    name: 'forecast-note-tables',
    components: {
        'loading': VueElementLoading
    },
    props: {
        year: Number,
        region: String,
        version: String,
        abp: Number,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        access_level: Number,
        table_number: Number,
        table_code: String,
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            open: false,
            allOpen: false,
            table1_1: [],
            formApp: [],
            currentView: 'pr6Inc',
            repdate: null,
            openRows: {},
            openCls: {},
            inputValues: [],
            enTableNumbers: [1, 3, 5, 7, 8, 11, 15, 18, 21, 23],
            changeTableNumbers: [2, 4, 6, 10, 12, 13, 14, 16, 19, 22, 24, 34],
            checkDataTableNumbers: [2, 4, 6, 10, 12, 13, 14, 16, 19, 20, 22, 24, 34, 36, 37],
            inputType8: ['011', '012', '013', '015', '016', '017'],
            inputType7: ['012', '013', '016'],
            totalRow: {
                fcat: 0,
                evaluation: 0,
                forecast_1: 0,
                forecast_2: 0,
                forecast_3: 0,
            },

        }
    },
    async mounted() {
        await this.LoadApplyButton();
    },
    computed: {
        forecastYears() {
            return [this.year - 2, this.year - 1, this.year, this.year + 1, this.year + 2];
        },
        tableFields1_1() {
            const [yearMinus2, yearMinus1, currentYear, yearPlus1, yearPlus2] = this.forecastYears;

            return [
                {
                    key: 'spf',
                    label: 'Специфика',
                    rowspan: 2
                },
                {
                    key: 'name_ru',
                    label: 'Наименование',
                    rowspan: 2
                },
                {
                    key: 'row_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: String(yearMinus2),
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: String(yearMinus1),
                    rowspan: 1
                },
                {
                    key: 'forecast_1',
                    label: String(currentYear)
                },
                {
                    key: 'forecast_2',
                    label: String(yearPlus1)
                },
                {
                    key: 'forecast_3',
                    label: String(yearPlus2)
                }
            ];
        },
        tableFields1_2() {
            const [yearMinus2, yearMinus1, currentYear, yearPlus1, yearPlus2] = this.forecastYears;

            return [
                {
                    key: 'name_ru',
                    label: 'Наименование',
                    rowspan: 2
                },
                {
                    key: 'row_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: String(yearMinus2),
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: String(yearMinus1),
                    rowspan: 1
                },
                {
                    key: 'forecast_1',
                    label: String(currentYear)
                },
                {
                    key: 'forecast_2',
                    label: String(yearPlus1)
                },
                {
                    key: 'forecast_3',
                    label: String(yearPlus2)
                }
            ];
        },
    },
    methods: {
        hasError(field) {
            return this.checkDataList.find(item =>
                item.agreed_form === 'note' && this.checkDataTableNumbers.includes(Number(item.table)) &&
                item[field]
            );
        },
        hasParentValues(row_code, field) {
            let parentCode = null

            if (this.table_number === 8) {
                parentCode = TABLE_8_CHILD_TO_PARENT[row_code]
            } else if (this.table_number === 7) {
                parentCode = TABLE_7_CHILD_TO_PARENT[row_code]
            }

            const parentRow = this.formApp.find(r => r.row_code === parentCode)
            if (!parentRow) return false

            const value = parentRow[field]

            return value !== null && value !== undefined && value !== 0
        },
        rowClass(item) {
            if (item !== null && item.spf === null &&
                this.table_number !== 36 &&
                this.table_number !== 37) {
                return 'bg-light-blue';
            }
            return '';
        },
        blurInput(data, line_code, isInitialLoad = false) {
            const field = data.field.key;
            const rawValue = data.value;
            const newValue = parseFloat(rawValue) || 0;

            const childRow = this.formApp.find(r => r.row_code === line_code);
            if (!childRow) return;

            this.$set(childRow, field, newValue);

            // TABLE 7: пересчёт строк
            if (this.table_number === 7) {
                const parentCode = TABLE_7_CHILD_TO_PARENT[line_code];
                if (parentCode) {
                    const parentRow = this.formApp.find(r => r.row_code === parentCode);
                    if (parentRow) {
                        const parentValue = parseFloat(parentRow[field]) || 0;

                        if (!data.item._prevValues) {
                            this.$set(data.item, '_prevValues', {});
                        }

                        const oldChildValue =
                            parseFloat(data.item._prevValues[field]) || 0;

                        const wasCleared = rawValue === '' || rawValue === null;

                        const result = wasCleared
                            ? parentValue + oldChildValue
                            : parentValue - (newValue - oldChildValue);

                        this.$set(parentRow, field, result);
                        this.$set(data.item._prevValues, field, newValue);
                    }
                }

                ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'].forEach(key => {
                    const sum = this.formApp
                        .reduce((acc, r) => acc + (parseFloat(r[key]) || 0), 0);

                    this.$set(this.totalRow, key, this.toNum(sum));
                });
            }

            // TABLE 8: пересчёт строк
            if (this.table_number === 8) {
                const parentCode = TABLE_8_CHILD_TO_PARENT[line_code];
                if (parentCode) {
                    const parentRow = this.formApp.find(r => r.row_code === parentCode);
                    if (parentRow) {
                        const parentValue = parseFloat(parentRow[field]) || 0;

                        if (!data.item._prevValues) {
                            this.$set(data.item, '_prevValues', {});
                        }

                        const oldChildValue =
                            parseFloat(data.item._prevValues[field]) || 0;

                        const wasCleared = rawValue === '' || rawValue === null;

                        const result = wasCleared
                            ? parentValue + oldChildValue
                            : parentValue - (newValue - oldChildValue);

                        this.$set(parentRow, field, result);
                        this.$set(data.item._prevValues, field, newValue);
                    }
                }

                ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'].forEach(key => {
                    const sum = this.formApp
                        .reduce((acc, r) => acc + (parseFloat(r[key]) || 0), 0);

                    this.$set(this.totalRow, key, this.toNum(sum));
                });

            }

            // TABLE 9: строка 100
            if (this.table_number === 9) {

                const mainRow = this.formApp.find(r => r.row_code === '100');
                const totalRows = ['010', '011'];

                ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'].forEach(key => {
                    const sum = this.formApp
                        .filter(r => totalRows.includes(r.row_code))
                        .reduce((acc, r) => acc + (parseFloat(r[key]) || 0), 0);

                    this.$set(mainRow, key, this.toNum(sum));
                });
            }

            if (isInitialLoad) return;
            // inputValues (для сохранения)
            let entry = this.inputValues.find(e => e.line_code === line_code);

            if (!entry) {
                entry = {line_code};
                this.inputValues.push(entry);
            }

            this.$set(entry, field, newValue);
        },
        async LoadApplyButton(){
            if (this.enTableNumbers.includes(this.table_number)) {
                await this.LoadDataTableAssets();
            } else if (this.changeTableNumbers.includes(this.table_number)) {
                await this.LoadDataTableChange();
            } else if (this.table_number === 9) {
                await this.LoadDataTable9();
            } else if (this.table_number === 20 || this.table_number === 25) {
                await this.LoadDataTable2025();
            } else if (this.table_number === 36 || this.table_number === 37) {
                await this.LoadDataTable3637();
            }
        },
        async LoadDataTableAssets() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_note_tables_assets/` + this.year +  '/' + this.version + '/' + this.abp + '/' + this.region + '/' + this.table_code + '/' + this.table_number);
                if (response.status === 200) {
                    this.formApp = await response.json();

                    if (this.table_number === 8) {
                        const keysToBlur = ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'];

                        this.formApp.forEach(row => {
                            keysToBlur.forEach(key => {
                                if (row[key] !== undefined) {
                                    this.blurInput(
                                        {
                                            item: row,
                                            field: { key },
                                            value: row[key]
                                        },
                                        row.row_code, true
                                    );
                                }
                            });
                        });
                    }
                    else if (this.table_number === 7) {
                        const keysToBlur = ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'];

                        this.formApp.forEach(row => {
                            keysToBlur.forEach(key => {
                                if (row[key] !== undefined) {
                                    this.blurInput(
                                        {
                                            item: row,
                                            field: { key },
                                            value: row[key]
                                        },
                                        row.row_code, true
                                    );
                                }
                            });
                        });
                    }
                    else {
                        const totalArray = this.formApp.filter(item => item.spf !== null && item.spf !== undefined);

                        ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'].forEach(key => {
                            const sum = totalArray.reduce(
                                (acc, item) => acc + (parseFloat(item[key]) || 0), 0);
                            this.$set(this.totalRow, key, this.toNum(sum));
                        });
                    }

                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTableChange() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_note_tables_assets_change/` + this.year + '/' + this.region + '/' + this.version + '/' + this.abp + '/' + this.table_code + '/' + this.table_number);
                if (response.status === 200) {
                    this.formApp = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки таблицы', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTable9() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_note_tables9/` + this.year  + '/' + this.version + '/' + this.abp);
                if (response.status === 200) {
                    this.formApp = await response.json();
                    const keysToBlur = ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'];

                    this.formApp.forEach(row => {
                        keysToBlur.forEach(key => {
                            if (row[key] !== undefined) {
                                this.blurInput(
                                    {
                                        item: row,
                                        field: { key },
                                        value: row[key]
                                    },
                                    row.row_code, true
                                );
                            }
                        });
                    });
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки Таблицы 9', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTable2025() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_note_tables2025/` + this.year + '/' + this.region  + '/' + this.version + '/' + this.abp + '/' + this.table_number);
                if (response.status === 200) {
                    this.formApp = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки таблицы', error.toString());
            }
            this.loading = false;
        },
        async LoadDataTable3637() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_note_tables3637/` + this.year + '/' + this.region + '/' + this.version + '/' + this.abp + '/' + this.table_number + '/' + this.table_code);
                if (response.status === 200) {
                    this.formApp = await response.json();
                    const totalArray = this.formApp.filter(item => item.spf !== undefined);

                    ['fact', 'evaluation', 'forecast_1', 'forecast_2', 'forecast_3'].forEach(key => {
                        const sum = totalArray.reduce(
                            (acc, item) => acc + (parseFloat(item[key]) || 0), 0);
                        this.$set(this.totalRow, key, this.toNum(sum));
                    });
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки таблицы', error.toString());
            }
            this.loading = false;
        },
        async SaveDataNote7() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'abp', this.abp);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.$set(item, 'table_num', this.table_number);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_pkfo_note7', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        async SaveDataNote9() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'abp', this.abp);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.$set(item, 'table_num', this.table_number);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_pkfo_note9', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.year, region: this.region, version: this.version, data_type: this.dataType, abp: this.abp, reg_name: this.region_name, ver_name: this.version_name, table_num: this.table_number, table_code: this.table_code };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_note_tables/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        const fileName = 'Пояснительная записка.xlsx';
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        toggleRow(index) {
            this.$set(this.openRows, index, !this.openRows[index]);
        },
        toNum(value, fix = 1) {
            if (typeof value === 'string') {
                if (value.trim() === '') {
                    return 0; // или можно вернуть null, если не хочешь показывать 0
                }
                const num = parseFloat(value.replace(',', '.'));
                return isNaN(num) ? 0 : parseFloat(num.toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }

    }
}
</script>

<style>
.bg-light-blue {
    background-color: #e8f4fa !important;
}
</style>

